import { useParams } from 'next/navigation';

import ImageProxy from '@next-image-proxy';

import { useLaunchpadProjectWithSalesQuery, useLaunchpadSaleQuery } from '@query';

const ProjectInfo = () => {
  const params = useParams<{ id: string; saleId: string }>();
  const { data: project, isPending: isLoadingProject } = useLaunchpadProjectWithSalesQuery(
    params.id,
  );

  const { data: sale, isPending: isLoadingSale } = useLaunchpadSaleQuery(params.saleId);

  const projectName = project?.attributes.name;
  const projectLogo = project?.attributes.logoUrl;
  const saleName = sale?.attributes.name;

  if (isLoadingProject || isLoadingSale) {
    return (
      <div className="flex mb-16 items-center gap-2">
        <div className="w-12 h-12 skeleton-block" />
        <div className="skeleton-text w-[200px] h-10" />
      </div>
    );
  }

  return (
    <div className="flex mb-16 items-center gap-2">
      <ImageProxy alt="logo" src={projectLogo} width={48} height={48} />
      <h1 className="text-[32px] font-semibold">
        {projectName} {saleName}
      </h1>
    </div>
  );
};

export default ProjectInfo;
